import { createSlice } from "@reduxjs/toolkit";
import {
	getBlogs,
	saveBlog,
	updateBlog,
	deleteBlog,
} from "services/blog.service";
import { initGlobalState } from "./default";
import { message } from "antd";

const blogSlice = createSlice({
	name: "blog",
	initialState: initGlobalState,
	reducers: {},
	extraReducers: (builder) => {
		builder
			// Save Blog
			.addCase(saveBlog.pending, (state) => {
				state.saveBlogLoading = true;
			})
			.addCase(saveBlog.fulfilled, (state) => {
				state.saveBlogLoading = false;
				message.success("Record added successfully");
			})
			.addCase(saveBlog.rejected, (state) => {
				state.saveBlogLoading = false;
			})
		
			// Get All Blogs
			.addCase(getBlogs.pending, (state) => {
				state.blogs.loading = true;
			})
			.addCase(getBlogs.fulfilled, (state, action) => {
				const { data, total, page, limit } = action.payload;
        const results = Array.isArray(data) ? data : [];

        if (page && page > 1) {
          state.blogs.data = [...state.blogs.data, ...results];
        } else {
          state.blogs.data = results ;
        }

        state.blogs.total = total;
        state.blogs.page = page;
        state.blogs.limit = limit;
        state.blogs.loading = false;
			})
			.addCase(getBlogs.rejected, (state) => {
				state.blogs.loading = false;
			})
		
			// Update Blog
			.addCase(updateBlog.pending, (state) => {
				state.updateBlogLoading = true;
			})
			.addCase(updateBlog.fulfilled, (state, action) => {
				state.updateBlogLoading = false;
				message.success("Record updated successfully");
					const index = state.blogs.data.findIndex(
						(item) => item.id == action.payload.id
					);
					if (index > -1) {
						state.blogs.data[index] = action.payload;
					}
			})
			.addCase(updateBlog.rejected, (state) => {
				state.updateBlogLoading = false;
			})
		
			// Delete Blog
			.addCase(deleteBlog.pending, (state) => {
				state.deleteBlogLoading = true;
			})
			.addCase(deleteBlog.fulfilled, (state, action) => {
				state.deleteBlogLoading = false;
				message.success("Record deleted successfully");
				state.blogs.data = state.blogs?.data.filter(
					(item) => item.id !== action.meta.arg
				);
			})
			.addCase(deleteBlog.rejected, (state) => {
				state.deleteBlogLoading = false;
			})
	},
});

export const {} = blogSlice.actions;

export default blogSlice.reducer;
